import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import * as Sentry from '@sentry/react'
import { createRootReducer } from './rootReducer'
import { rootSaga } from './rootSaga'

const sagaMiddleware = createSagaMiddleware()

export const history = createBrowserHistory()

export const store = configureStore({
	reducer: createRootReducer(history),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
			immutableCheck: false,
			thunk: true,
		}).concat([sagaMiddleware, routerMiddleware(history)]),
	devTools: process.env.MODE === 'dev',
	enhancers: [Sentry.createReduxEnhancer({})],
})
sagaMiddleware.run(rootSaga)

export type AppStore = typeof store
export type AppState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']

export { sagaCallbackChannel } from './rootSaga'
